import { Button, Grid, Typography } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link, useParams } from "react-router-dom";

const CompleteIntro = ({mainImage,name}) => {

  const {slugAssessment}=useParams();

  return (
    <Grid container spacing={5} sx={{marginTop:"50px"}}>
        <Grid size={6}>
            <Typography component={"div"} variant="h5" color="secondary" fontWeight={400} sx={{marginTop:"40px",lineHeight:"1.5"}} dangerouslySetInnerHTML={{ __html: `Thank you for completing the ${name}.` }}></Typography>
            <Typography variant="h5" color="secondary" fontWeight={400} sx={{marginTop:"40px",lineHeight:"1.5"}}>Click Next to see your results.</Typography> 
            <Button component={Link} to={`/${slugAssessment}/report`} className="assessmentCardButton borderButtonGreen" variant="contained" startIcon={<ArrowForwardIcon className="invertIcon"/>} sx={{color:"white",marginTop:"25px"}}>Next</Button>
        </Grid>
        <Grid size={6} display="flex" justifyContent="center">
            <img className="assesmentMainImageBig" src={mainImage} alt="Assessment Logo"/>
        </Grid>
    </Grid>
  )
}

export default CompleteIntro